module.exports = __webpack_public_path__ + "static/media/17.4bfdb242.ogg";